import React, {Component} from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <span><a href="https://genesisui.com">Prime</a> &copy; 2018 creativeLabs.</span>
        <span className="ml-auto">Powered by <a href="https://genesisui.com">GenesisUI</a></span>
      </footer>
    )
  }
}

export default Footer;
